import { useSelector } from "react-redux";
import { getUrlQuerysection } from "../../../../../../helpers";
import { useUrlSearch } from "../../../../../../hooks/useUrlSearch";
import { purchaseOrderStatus } from "../../../../../../localdata";
import {
  useGetGoodsReceived,
  useGetSuppliers,
} from "../../../../../../hooks/api/queries";
import { useEffect } from "react";

export const useAllGoodsReceived = () => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const queries = getUrlQuerysection();
  const {
    search,
    gotoPage,
    filterByStoreId,
    filterBySearch,
    filterByKey,
    filterByDate,
  } = useUrlSearch();

  const { isLoading: isLoadingGRN, data } = useGetGoodsReceived({ queries });
  const { data: suppliers, isLoading: isLoadingSupplier } = useGetSuppliers();

  useEffect(() => {
    if (!search.get("status")) filterByKey("status", "IN_REVIEW");
  }, []);

  return {
    isLoadingExtra: isLoadingSupplier,
    isLoadingGRN,
    goodsReceived: data?.data,
    metaDetails: data?.meta,
    search,
    storeList,
    goodsReceivedStatus: purchaseOrderStatus,
    suppliers: suppliers || [],
    filterByDate,
    filterByStoreId,
    filterBySearch,
    gotoPage,
    filterByKey,
  };
};
